const GetDataSystem = 
  `query Query($id:String!, $deliveryConfigCount: Int, $deliveryConfigCursor: String) {
    dataSystem(id: $id) {
      id
      name
      description
      deliveryConfigs(first: $deliveryConfigCount, after: $deliveryConfigCursor) {
        pageInfo {
          hasNextPage
        }
        edges {
          cursor
          node {
            id
            name
            description
            dataType {
              id
              name
              description
            }
            sender {
              id
              name
              description  
            }
            receiver {
              id
              name
              description  
            }
            deliveryService
          }
        }
      }
    }
  }
  `

const GetDataSystems = 
  `query Query($count: Int, $cursor: String, $filterConfig: DataSystemFilterConfigInput) {
    dataSystems(first: $count, after: $cursor, filterConfig: $filterConfig) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          name
          # description
        }
      }   
    }
  }
  `
  
  module.exports = {
    GetDataSystem,
    GetDataSystems,
  }